<template>
    <!--tag标签展示-->
    <div class="tagList">
        <!--暂无标签-->
        <!-- <Tag v-if="subArray.length===0">
            <span class="noItem">{{$t('暂无标签')}}</span>
        </Tag> -->
        <Tag v-for="(item,i) in subArray"
             :key="'val'+i"
             :color="item.rgbCode">
            <span class="tagItem rc-ellipsis"
                  :title="item.tagName+':'+item.tagValue">{{ item.tagValue ? item.tagName + ':' + item.tagValue : item.tagName }}</span>
        </Tag>
        <!--更多标签-->
        <Tag class="icon-more-tag"
             :style="values.childs.length>1 ? 'display: inline-block;' : ''">
            <span class="icon-more-1-o"
                  title="更多"
                  @click="showBindWindow(values.id)"></span>
        </Tag>
        <!--绑定标签-->
        <!-- <span @click="showBindWindow(values.id)"
              title="绑定标签"
              class="icon-increase-1-o addIcon">
        </span> -->
    </div>
</template>
<script>
export default {
    name: 'Poptip',
    props: {
        // 自定义标签数组
        values: {
            type: Object
        }
    },
    computed: {
        subArray () { return this.values.childs.slice(0, 1) }
    },
    methods: {
        // 删除
        cancel () {
            this.visible = false
            this.$emit('on-cancel')
        },
        // 确认
        ok () {
            this.visible = false
            this.$emit('on-ok')
        },
        // 操作弹窗
        showBindWindow () {
            this.$emit('showBindWindow')
        }
    }
}
</script>
<style lang="less" scoped>
.tagList {
    padding-right: 20px;
    width: 100%;
    min-height: 22px;
    .addIcon {
        color: #3498dc;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -8px;
        display: none;
    }
    .addIcon:before {
        font-size: 16px;
    }
    .ivu-tag {
        cursor: default;
    }
    // .noItem {
    //     color: #999;
    //     display: inline-block;
    //     width: 100%;
    //     height: 100%;
    //     cursor: default;
    // }
    .tagItem {
        display: inline-block;
        width: 100%;
        max-width: 100px;
        height: 100%;
        cursor: default;
    }
    .icon-more-tag {
        display: none;
    }
    .icon-more-1-o {
        transform: rotate(90deg);
        color: #999;
        display: inline-block;
        cursor: pointer;
        display: block;
        height: 30px;
        width: 21px;
        margin-top: -3px;
        text-align: center;
        line-height: 30px;
    }
}
.tagList:hover {
    .icon-more-tag {
        display: inline-block;
    }
    .addIcon {
        display: block;
    }
}
.ivu-tag {
    height: 23px;
}
.ivu-tag-text {
    cursor: default;
}
</style>
